<template>
  <div class="hm-check-box-group mt-4 mb-4">
    <div class="d-flex">
      <div>
        <div
          class="d-flex justify-content-between mb-3 labels scale-labels-block"
        >
          <span v-if="startText" class="pe-1">{{ startText }}</span>
          <span v-else class="pe-1">{{ $t('QUIZZES.LABEL.NOT_LIKELY') }}</span>
          <span v-if="endText">{{ endText }}</span>
          <span v-else>{{ $t('QUIZZES.LABEL.EXTREMELY_LIKELY') }}</span>
        </div>
        <div class="d-flex">
          <span v-for="i in range" :key="i" class="d-flex">
            <HMRadio
              :modelValue="modelValue"
              @update:modelValue="newValue => $emit('update:modelValue', newValue)"
              group="price-options"
              :name="i"
            >
            </HMRadio>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
interface LocalProps {
  range: PropOptions;
  modelValue: PropOptions;
  startText: PropOptions;
  endText: PropOptions;
}

export default {
  name: 'HMOpinionScale',
  props: {
    range: {
      type: Number,
      default: null,
    },
    modelValue: {
      type: Number,
      default: null,
    },
    startText: {
      type: String,
      default: null,
    },
    endText: {
      type: String,
      default: null,
    },
  } as LocalProps,
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
.labels {
  font-size: 10px;
  color: $charcoal;
}

.scale-labels-block {
  padding-right: 25px;
}
</style>
